import { useEffect, useState, useRef } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import { BASEAPIURL, getCategoryURL, UPLOADNODEURL } from '../../config';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { useTranslation } from 'react-i18next';

function FeaturedCategoriesSlider() {
    const { t } = useTranslation();
    const [CatiData1, setCatiData1] = useState([]);
    const [CatiData2, setCatiData2] = useState([]);
    const sliderRef = useRef();
    const settings = {
        autoplay: false,
        arrows: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
        ],
    };

    const minCatCount = 3;

    const FetchCatiData = async () => {
        try {
            const res = await fetch(`${BASEAPIURL}/admin/coursecategory/getAll`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    SortStatus: 1,
                    recordsPerPage: 100,
                    sortby: 'a2z',
                    parent: 0, // 'all',
                    featured: 0,
                }),
            });
            const resJson = await res.json();
            if (res.status === 200) {
                if (Object.keys(resJson.data).length > 0) {
                    setCatiData1(resJson.data.filter(item => item.maincatid === 'courses'));
                    setCatiData2(resJson.data.filter(item => item.maincatid === 'eproducts'));
                    console.log("##############");
                    console.log(resJson.data.filter(item => item.maincatid === 'courses'));
                    console.log("##############");
                    console.log(resJson.data.filter(item => item.maincatid === 'eproducts'));
                    console.log("##############");
                }
            } else {
                console.log(resJson.message);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        FetchCatiData();
    }, []);

    function getCatLink(catData) {
        return getCategoryURL(catData.maincatid, catData.catid, catData.parent);
    }

    const [tab, setTab] = useState('setting');
    const handleClick = (e, value) => {
        e.preventDefault();
        setTab(value);
    };

    return (
        <>
            <section className={`appie-features-area FeaturedCategoriesSlider gray-bg ${CatiData1.length > minCatCount && CatiData1.length > 3 ? '' : 'd-none'}`}>
                <div className="container">
                    <div className="appie-section-title text-center">
                        <h4
                            className="mb-4 text-center"
                            style={{
                                borderBottom: '3px solid #dbae13',
                                display: 'inline-block',
                                padding: '0px 50px 5px',
                            }}
                        >
                            {t('discover')}
                        </h4>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="appie-features-tabs-btn">
                                <div
                                    className="nav nav-pills justify-content-center mb-30"
                                    style={{ gap: '10px' }}
                                    id="v-pills-tab"
                                    role="tablist"
                                    aria-orientation="vertical"
                                >
                                    <a
                                        onClick={(e) => handleClick(e, 'setting')}
                                        className={`${CatiData1.length > minCatCount ? '' : 'd-none'} nav-link ${tab === 'setting' ? 'active' : ''}`}
                                        id="v-pills-courses-tab"
                                        data-toggle="pill"
                                        href="#v-pills-courses"
                                        role="tab"
                                        aria-controls="v-pills-courses"
                                        aria-selected="true"
                                    >
                                        {t('courses')}
                                    </a>
                                    <a
                                        onClick={(e) => handleClick(e, 'report')}
                                        className={`${CatiData2.length > minCatCount ? '' : 'd-none'} nav-link ${tab === 'report' ? 'active' : ''}`}
                                        id="v-pills-products-tab"
                                        data-toggle="pill"
                                        href="#v-pills-products"
                                        role="tab"
                                        aria-controls="v-pills-products"
                                        aria-selected="false"
                                    >
                                        {t('eProducts')}
                                    </a>
                                </div>
                            </div>
                            <div className="tab-content" id="v-pills-tabContent">
                                <div
                                    className={`${CatiData1.length > minCatCount ? '' : 'd-none'} ${tab === 'setting' ? 'show active' : ''} tab-pane fade`}
                                    id="v-pills-courses"
                                    role="tabpanel"
                                    aria-labelledby="v-pills-courses-tab"
                                >
                                    <div className="appie-showcase-slider align-items-center">
                                        <div className="CategoryChooseFilter">
                                            <Slider ref={sliderRef} {...settings}>
                                                {CatiData1.map((cti) => (
                                                    <>
                                                        {cti.maincatid === "courses" && (
                                                            <div key={cti.catid} title={cti.title}>
                                                                <div className="appie-features-content">
                                                                    <a
                                                                        href={getCatLink(cti)}
                                                                        className="imgBox text-center"
                                                                        style={{ cursor: 'pointer' }}
                                                                    >
                                                                        <label
                                                                            htmlFor={`catiid${cti.catid}`}
                                                                            className="mb-0"
                                                                        >
                                                                            <img
                                                                                src={cti.image ? `${UPLOADNODEURL}${cti.image}` : '/logo.png'}
                                                                                alt={cti.image}
                                                                            />
                                                                            <div className="cti_titl">
                                                                                <b style={{ color: '#000' }}>{cti.title}</b>
                                                                            </div>
                                                                        </label>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </>
                                                ))}
                                            </Slider>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={`${CatiData2.length > minCatCount ? '' : 'd-none'} ${tab === 'report' ? 'show active' : ''} tab-pane fade`}
                                    id="v-pills-products"
                                    role="tabpanel"
                                    aria-labelledby="v-pills-products-tab"
                                >
                                    <div className="appie-showcase-slider align-items-center">
                                        <div className="CategoryChooseFilter">
                                            <Slider ref={sliderRef} {...settings}>
                                                {CatiData2.map((cti) => (
                                                    <div key={cti.catid} title={cti.title}>
                                                        <div className="appie-features-content">
                                                            <Link
                                                                to={getCatLink(cti)}
                                                                className="imgBox text-center"
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                <label
                                                                    htmlFor={`catiid${cti.catid}`}
                                                                    className="mb-0"
                                                                >
                                                                    <img
                                                                        src={cti.image ? `${UPLOADNODEURL}${cti.image}` : '/logo.png'}
                                                                        alt={cti.image}
                                                                    />
                                                                    <div className="cti_titl">
                                                                        <b style={{ color: '#000' }}>{cti.title}</b>
                                                                    </div>
                                                                </label>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                ))}
                                            </Slider>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default FeaturedCategoriesSlider;
